import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import * as DataList from 'components/DataList';
import SettingsPage from 'components/SettingsPage';
import PreferencesProfileCard from 'components/Preference/ProfileCard';

// Settings > Payment settings (/preferences).
@inject('preferenceStore') @observer
class PreferencesIndexPage extends Component {

  componentDidMount() {
    this.props.preferenceStore.loadPreferences();
  }

  render() {
    const { preferenceStore } = this.props;
    const { isLoading, isError, object } = preferenceStore.preference;
    let content = null;
    if (object && object.attributes) {
      content = <PreferencesProfileCard preference={object.attributes} />;
    } else if (isError && !isLoading) {
      content = (
        <DataList.Notice
          tone="error"
          icon="error"
          role="alert"
          title="Payment settings couldn't be loaded"
          message="Something went wrong on our side. Try again in a moment."
          actions={[{ label: 'Try again', icon: 'refresh', onClick: () => preferenceStore.loadPreferences(), primary: true }]}
        />
      );
    } else if (isLoading) {
      content = <div className="sp-card sp-card--loading" aria-label="Loading payment settings" role="status"><span className="dl-bone" style={{ width: 220, height: 16 }} /><span className="dl-bone" style={{ width: '100%', height: 72 }} /><span className="dl-bone" style={{ width: 160, height: 36 }} /></div>;
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Payment settings | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Payment settings"
          description="How customers pay your invoices online, and when invoices are due."
        >
          {content}
        </SettingsPage>
      </React.Fragment>
    );
  }
}

export default PreferencesIndexPage;
